import {
  ButtonSubmitText,
  StyledButtonSubmit,
} from "components/ButtonSubmit/style";
import styled from "styled-components";
import { Container, FlexContainer, theme } from "ui";

interface ProductProps {
  isClientMobile?: boolean;
}

interface MainProductContainerProps {
  isBlackTheme?: boolean;
}

export const MainProductContainer = styled(
  FlexContainer
)<MainProductContainerProps>`
  background-color: ${({ isBlackTheme }) =>
    isBlackTheme
      ? `${theme.colors.blackFriday["185"]}`
      : `${theme.colors.blackFriday["10"]}`};
`;

export const ProductContainer = styled(Container)`
  width: 100%;
  overflow: hidden;

  @media ${theme.device.desktopFirst.tabletS} {
    padding: 0 1.34rem;
  }
`;

export const WrapperLoading = styled.section<ProductProps>`
  width: 100%;
  height: 0.625rem;
  display: flex;
  justify-content: center;
  margin-bottom: 3rem;
  position: fixed;
  bottom: ${({ isClientMobile }) => (isClientMobile ? "15rem" : "4rem")};
  right: 0;
  z-index: 9999999;

  ${StyledButtonSubmit} {
    flex-direction: row-reverse;
    background-color: ${theme.colors.neutral.white};

    opacity: 1;

    border-radius: 12.5rem;

    ${ButtonSubmitText} {
      color: ${theme.colors.neutral["999"]};
    }
  }
`;
export interface SearchResultContentProps {
  padding?: string;
}
export const SearchResultHeader = styled.div<SearchResultContentProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: ${({ padding }) => padding || "0 0"};
  border-bottom: 1px solid ${theme.colors.neutral["95"]};
`;

export const SearchResultTitle = styled.div<SearchResultContentProps>`
  font-size: 2rem;
  font-weight: bold;
  letter-spacing: -1px;
  margin-bottom: 1.3rem;
  color: ${theme.colors.neutral["520"]};
`;

export const SearchResultCounter = styled.div<SearchResultContentProps>`
  text-transform: uppercase;
  font-size: 1.1rem;
  font-weight: bold;
  color: ${theme.colors.neutral["520"]};
`;

export const SearchResultContent = styled.div<SearchResultContentProps>`
  display: grid;
  grid-template-columns: 20% 80%;
  padding: ${({ padding }) => padding || "0 0"};
`;

export const BoxSelect = styled.div<SearchResultContentProps>``;

export const SelectSortBy = styled.div<SearchResultContentProps>`
  display: flex;
  flex-flow: column nowrap;
  align-items: start;
  position: relative;
  z-index: 5;

  label {
    margin: 0.5rem 0 0.5rem 1rem;
    color: ${theme.colors.neutral["520"]};
  }

  .react-select {
    &__control {
      width: 180px;
      border-radius: 4px;
      height: 3.5rem;
      position: relative;
      border: thin solid ${theme.colors.primary["200"]};
      background-color: transparent;
      appearance: none;
      font-size: 1.3rem;
      color: ${theme.colors.primary["200"]};
      outline: none;
      cursor: pointer;

      &:hover {
        border-color: ${theme.colors.primary["300"]};
      }
    }

    &__single-value {
      color: ${theme.colors.primary["200"]};
    }

    &__indicator-separator {
      opacity: 0;
    }

    &__indicator {
      color: ${theme.colors.primary["200"]};
    }

    &__option {
      font-size: 1.3rem;
    }
  }
`;

export const PaymentMethodsMobileContainer = styled.section`
  padding: 2rem 1rem 8rem 1rem;
`;
